import { persister, queryClient } from "src/providers/queryClient";
import { sealPersistentStorage } from "./persistentStorage";
import sentryService from "services/SentryService";
import { useAuthStore } from "stores/authStore";

const DEVICE_SCOPED_STORAGE_KEYS = ["i18nextLng", "version"];

const clearUserScopedStorage = (): void => {
  Object.keys(localStorage)
    .filter(key => !DEVICE_SCOPED_STORAGE_KEYS.includes(key))
    .forEach(key => localStorage.removeItem(key));
};

let isLoggingOut = false;
let isHandlingUnauthorized = false;

export const beginLogout = (): boolean => {
  if (isLoggingOut) {
    return false;
  }

  isLoggingOut = true;
  return true;
};

export const endLogout = (): void => {
  isLoggingOut = false;
};

export const isLogoutInProgress = (): boolean => isLoggingOut;

export const beginUnauthorizedTeardown = (): boolean => {
  if (isHandlingUnauthorized || isLoggingOut) {
    return false;
  }

  isHandlingUnauthorized = true;
  return true;
};

export const endUnauthorizedTeardown = (): void => {
  isHandlingUnauthorized = false;
};

export const clearIdentityState = async (): Promise<void> => {
  sealPersistentStorage();

  useAuthStore.getState().reset();
  useAuthStore.persist.clearStorage();

  try {
    await queryClient.cancelQueries();
    queryClient.clear();
    await persister.removeClient();
  } catch (error) {
    console.error(error);
  }

  sentryService.setUser();
};

export const clearClientState = async (): Promise<void> => {
  await clearIdentityState();

  clearUserScopedStorage();
};
